import React from "react";
import {Pane, Checkbox} from "evergreen-ui";

const DaysSelector = (props) => {

    const {
        days,
        allDaysIsChecked,
        selectAllDays,
        selectDay,
        paddingLeft,
        paddingRight,
    } = props;

    return (
        <Pane
            paddingLeft={paddingLeft}
            paddingRight={paddingRight}
            display={"flex"}
            flexWrap={"wrap"}
            justifyContent={"space-between"}
            alignItems={"center"}
        >
            <Checkbox
                width={"25%"}
                label="All Days"
                checked={allDaysIsChecked}
                onChange={e => selectAllDays(e.target.checked)}
                marginTop={4}
                marginBottom={0}
            />
            {days.map(day => (
                <Checkbox
                    width={"25%"}
                    key={day.id}
                    label={day.day}
                    checked={day.checked}
                    onChange={e => selectDay(day.id, e.target.checked)}
                    marginTop={4}
                    marginBottom={0}
                />
            ))}
        </Pane>
    );
};

export default DaysSelector;
